import { render, staticRenderFns } from "./ProfilePrivilegesTab.vue?vue&type=template&id=3307bda8"
import script from "./ProfilePrivilegesTab.vue?vue&type=script&lang=js"
export * from "./ProfilePrivilegesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports